import { createFileRoute } from "@tanstack/react-router";

import Stats from "./-components/Stats";

export const Route = createFileRoute("/_app/_dashboard/$planId/stats/$tab")({
  component: Stats,
});
